import PropTypes from 'prop-types';

const projectServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  getProjectsList: PropTypes.func,
  getProject: PropTypes.func,
  getProjectActivityList: PropTypes.func,
  getProjectExportList: PropTypes.func,
  getProjectCollaboratorSummary: PropTypes.func,
  projectGrantPermission: PropTypes.func,
  projectRevokePermission: PropTypes.func,
  publishProjectActivity: PropTypes.func,
  deleteProject: PropTypes.func,
  moveProject: PropTypes.func,
  updateProjectConfig: PropTypes.func,
  replaceProject: PropTypes.func,
  projectActivityDuplicate: PropTypes.func,
  projectActivityDelete: PropTypes.func,
  getProjectDetails: PropTypes.func,
  startIngestion: PropTypes.func,
  workspaceProjectSubscribe: PropTypes.func,
  workspaceProjectUnsubscribe: PropTypes.func,
  getIngestionLogs: PropTypes.func,
  deleteIngestion: PropTypes.func,
  getRootImportList: PropTypes.func,
});

export default projectServiceShape;
